import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjPreference"
});
const _hoisted_1 = {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M10.8993 2.00273H3.49956C3.49956 2.92458 3.49977 6.05811 3.49977 6.38949L3.49964 9.70456C3.49964 10.0359 3.49886 13.7511 3.49905 14.0031C3.49905 14.0031 12.5346 14.0031 12.88 14.0031C13.2254 14.0031 13.0492 14.0031 13.5054 14.0031L13.5054 2.00164C13.196 2.00079 11.2447 2.00273 10.8993 2.00273Z",
  stroke: "#42526E",
  "stroke-width": "1.3",
  "stroke-linecap": "square",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.60156 8.9582C5.60156 8.79252 5.73588 8.6582 5.90156 8.6582H11.1017C11.2674 8.6582 11.4017 8.79252 11.4017 8.9582V9.70527C11.4017 9.87096 11.2674 10.0053 11.1017 10.0053H5.90156C5.73588 10.0053 5.60156 9.87096 5.60156 9.70527V8.9582Z",
  fill: "#8E97A8"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.60156 11.2287C5.60156 11.063 5.73588 10.9287 5.90156 10.9287H9.00162C9.1673 10.9287 9.30162 11.063 9.30162 11.2287V11.9719C9.30162 12.1376 9.1673 12.2719 9.00162 12.2719H5.90156C5.73588 12.2719 5.60156 12.1376 5.60156 11.9719V11.2287Z",
  fill: "#8E97A8"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.0796 4.34618C11.2749 4.54144 11.2749 4.85802 11.0796 5.05328L8.4674 7.66548C8.15498 7.9779 7.64845 7.9779 7.33603 7.66548L5.92387 6.25332C5.7286 6.05805 5.7286 5.74147 5.92387 5.54621L6.34813 5.12195C6.54339 4.92668 6.85997 4.92668 7.05524 5.12195L7.90172 5.96842L9.94823 3.92191C10.1435 3.72665 10.4601 3.72665 10.6553 3.92191L11.0796 4.34618Z",
  fill: "#68758B"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_6);
}
var SJ_preference = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_preference as default };
